export const Interval = {
    SETUP_WORKER_SPEED: {
        min: 0,
        max: 10,
    },
    WORKER_COUNT: {
        min: 0,
        max: 15,
    },
    SCHEDULE_MAX_WORKFLOW: {
        min: 3,
        max: 5,
    },
    SCHEDULE_MAX_FOLLOW_WORKFLOW: {
        min: 0,
        max: 3,
    },
    DIVIDE_RATE: {
        min: 0,
        max: 100,
    },
    AGING_WEIGHT: {
        min: 0,
        max: 30,
    },
    SETTING_WEIGHT: {
        min: 0,
        max: 30,
    },
    UNLOCK_WEIGHT: {
        min: 0,
        max: 30,
    },
    MAX_WORKER_COUNT: {
        min: 0,
        max: 10,
    },
    SCHEDULE_LIMIT_LIKE_GROUP1: {
        min: 0,
        max: 50,
    },
    SCHEDULE_LIMIT_LIKE_GROUP2: {
        min: 0,
        max: 50,
    },
    SCHEDULE_LIMIT_LIKE_GROUP3: {
        min: 0,
        max: 50,
    },
    SCHEDULE_LIMIT_LIKE_DEFAULT: {
        min: 0,
        max: 50,
    },
    SCHEDULE_LIMIT_FOLLOW_GROUP1: {
        min: 0,
        max: 50,
    },
    SCHEDULE_LIMIT_FOLLOW_GROUP2: {
        min: 0,
        max: 50,
    },
    SCHEDULE_LIMIT_FOLLOW_GROUP3: {
        min: 0,
        max: 50,
    },
    SCHEDULE_LIMIT_FOLLOW_DEFAULT: {
        min: 0,
        max: 50,
    },
};
